import { Action } from 'redux'
import { DateActions } from '../../../reducers/bookingCalendar/actionNames'

const changeDateRendered = (
  startDate: Date,
  finishDate: Date,
  isManual = false,
): IChangeDateRenderedAction => ({
  finishDate,
  isManual,
  startDate,
  type: DateActions.ChangeDateRangeRendered,
})

const changeDateScrollable = (
  startDate: Date,
  finishDate: Date,
): IChangeDateScrollableAction => ({
  finishDate,
  startDate,
  type: DateActions.ScrollableDateRangeChanging,
})

const changedDateScrollable = (
  startDate: Date,
  finishDate: Date,
): IChangeDateScrollableAction => ({
  finishDate,
  startDate,
  type: DateActions.ScrollableDateRangeChanged,
})

const changeDateManual = (startDate: Date): IChangeManualDateAction => {
  return {
    startDate,
    type: DateActions.ChangeManualDate,
  }
}

const changedDateManual = (startDate: Date): IChangeManualDateAction => {
  return {
    startDate,
    type: DateActions.ChangedManualDate,
  }
}

export {
  changeDateManual,
  changedDateManual,
  changeDateRendered,
  changeDateScrollable,
  changedDateScrollable,
}

export interface IChangeDateRenderedAction
  extends Action<DateActions.ChangeDateRangeRendered> {
  startDate: Date
  finishDate: Date
  isManual?: boolean
}

export interface IChangeDateScrollableAction
  extends Action<| DateActions.ScrollableDateRangeChanging
    | DateActions.ScrollableDateRangeChanged> {
  startDate: Date
  finishDate: Date
}

export interface IChangeManualDateAction
  extends Action<DateActions.ChangeManualDate | DateActions.ChangedManualDate> {
  startDate: Date
}
